import React from 'react';

import {Enzyme} from 'molbio/enzymes/backbone/Enzymes';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface EnzymeListRowProps {
  enzyme: Enzyme;
  writable: boolean;
}

function EnzymeListRow({enzyme, writable}: EnzymeListRowProps): JSX.Element {
  return (
    <>
      <td className="mono">{enzyme.name()}</td>
      {writable && (
        <td className="mono remove">
          <span className="close">&times;</span>
        </td>
      )}
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<EnzymeListRowProps>(EnzymeListRow);
